/**
 * @description Hook to get the plan from the auth context
 * @returns {Plan | null} The plan object or null if not authenticated
 */
import { useAuth } from "@/features/auth/hooks/useAuth";
import type { Plan } from "@/features/auth/types/plan.type";

export const usePlan = (): Plan | null => {
  const { plan } = useAuth();
  return plan;
};
